
<div
    class="w-100 "
    :class="border ? 'lm-border pa-2 pr-6' : ''"
    style="height: 200px;"
>
    <div
        :class="border ? 'ma-2' : 'ma-0'"
        v-html="text"
    >
    </div>
</div>
